<template>	<div>
		<div class="main flex_start">
			<div class="sideNav">
				<sideNav></sideNav>
			</div>
			<div class="mainPage">
				<div style="height: 64px;"></div>
				<div class="navTop flex_start" :style="{ left: getIsCollapseStatus?'64px':''}">
					<div class="isCollapseMenu" @click="changeCollapseStatus"><i class="el-icon-s-fold"></i></div>
					<div class="msgImg" @click="msgDrawChange">
						<img src="../assets/icon/msg.png" alt="">
						<div class="newMsgLabel" v-if="getMsgReadStatus == 1"></div>
					</div>
					<div class="splitLine"></div>
					<el-dropdown>
						<div class="userHead flex_center">
							<div class="headImg">
								<img v-if="avatar" :src="avatar" alt="">
								<img v-else src="../assets/icon/user.png" alt="">
							</div>
							<div class="userName">{{userInfo.userName}}</div>
							<i class="el-icon-arrow-down el-icon--right"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item><div @click="personalCenter">个人中心</div></el-dropdown-item>
							<el-dropdown-item><div @click="loginout">退出登录</div></el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<breadcrumb></breadcrumb>
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</div>
		</div>
		<el-drawer @close="closeDrawer" :visible.sync="msgDrawShow" size="46%" :wrapperClosable="false"
			:with-header="false">
			<div class="drawHead space_between">
				<div class="drawTitles flex_start">
					<div>消息</div>
					<img @click="msgAllSetRead" src="../assets/icon/clearUnread.png" alt="" />
				</div>
				<i class="el-icon-circle-close" @click="msgDrawShow=false"></i>
			</div>
			<div class="msgBox flex_start">
				<div class="msgLeft">
					<div class="leftMsgRow flex_start" v-for="(item,index) in msgTabList" :key="index"
					:class="{leftTabActive:activeTabMsg == item.title}" @click="msgTabChange(item)">
						<img :src="item.icon" alt="" />
						<div>{{item.title}}</div>
					</div>
				</div>
				<div class="msgRight">
					<div class="msgRightBox">
						<div class="msgRightList" v-if="msgDataList.length>0">
							<div class="msgRightRow" v-for="(item,index) in msgDataList" :key="index">
								<div class="msgRightTitRow flex_start">
									<div class="redLabel" v-if="item.isRead == 0"></div>
									<div class="msgTitle">{{item.title}}</div>
									<div class="infoBtn" @click="msgInfo(item)">详情 <i class="el-icon-arrow-right"></i></div>
								</div>
								<div class="msgCont">{{item.remark}}</div>
								<div class="msgSplitLine"></div>
								<div class="msgCont">{{item.addDate}}</div>
							</div>
						</div>
						<div v-else class="emptyBox">
							<el-empty description="暂无消息"></el-empty>
						</div>
					</div>
					<div class="paging flex_end">
						<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-drawer>
	</div></template><script>
	import sideNav from "../components/side_nav.vue";
	import breadcrumb from "../components/breadcrumb/breadcrumb.vue";
	import router from '@/router';	export default {
		components:{sideNav,breadcrumb},
		data() {			return {				token:'',
				userImg:'',
				stationName:'',
				searchInput:'',
				userInfo: {},
				msgDrawShow: false,
				msgTabList: [
					{title: '审批待办',icon: require('../assets/icon/approval.png'),type: 2},
					{title: '系统消息',icon: require('../assets/icon/systemMsg.png'),type: 1}
				],
				activeTabMsg: '审批待办',
				msgType: 2,
				msgDataList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
			}		},
		computed:{
			avatar() {
				return this.$store.state.avatar
			},
			getMsgReadStatus() {
				return this.$store.getters.getMsgReadStatus
			},
			getIsCollapseStatus(){
				return this.$store.getters.getIsCollapseStatus
			}
		},		methods: {			// 根据设备宽度初始化侧导航，平板及手机默认保持折叠状态
			initMenuCollapseStatus() {
				// 1024px 及以下覆盖常见平板和手机的横竖屏宽度
				const isMobileOrTablet = window.matchMedia('(max-width: 1024px)').matches
				if (isMobileOrTablet) {
					this.$store.commit('changeMenuStatus', true);
				}
			},
			// 获取当前账号信息
			async getUserInfo(){
				this.$http.get(this.$api.getUserInfo);
				console.log(res);
				if (res.code == 200) {
					// this.userImg = res.data.im
					// this.$store.commit('changeAvatar',res.data.avatar_image);
					// this.stationName = res.data.img.stationName
				}
			},
			searchCenter(){
				this.$router.push({
					path: '/Loan/DataLike/index',
					query: {
						powerId: '201',
						searchInput:this.searchInput
					}
				})
			},
			changeCollapseStatus(){
				this.$store.commit('changeMenuStatus', !this.getIsCollapseStatus);
			},
			msgDrawChange(){
				this.msgDrawShow = true
				this.getMsgData();
			},
			closeDrawer(){
				this.msgDrawShow = false
			},
			msgTabChange(item){
				this.activeTabMsg = item.title
				this.msgType = item.type
				this.currentPage = 1
				this.getMsgData();
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getMsgData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getMsgData();
			},
			async getMsgData(){
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					type: this.msgType
				}
				let res = await this.$http.post(this.$api.common.messageList, data);
				this.msgDataList = res.data.list
				this.total = res.data.totalRecord
			},
			async msgAllSetRead(){
				let res = await this.$http.post(this.$api.common.setAllReadStatus);
				if(res.code == 1){
					this.currentPage = 1
					this.$store.commit('changeReadStatus', 2);
					this.getMsgData();
				}
			},
			async getFirstUnRead(){
				let res = await this.$http.post(this.$api.common.getFirstUnRead);
				if(res.data){
					this.$store.commit('changeReadStatus', 1);
				}else{
					this.$store.commit('changeReadStatus', 2);
				}
			},
			async msgInfo(item){
				if(item.isRead == 0){
					let data = {
						id: item.id,
						isRead: 1,
					}
					let res = await this.$http.post(this.$api.common.setReadStatus, data);
					this.getFirstUnRead();
				}
				if(item.redirectType == 3){
					this.$router.push({
						path: '/approvalPending/applicationQuality',
						query: {
							sideId: 73,
							keyword: item.keyword
						}
					})
				}else if(item.redirectType == 2){
					this.$router.push({
						path: '/approvalPending/comanyQuality',
						query: {
							sideId: 72,
							keyword: item.keyword
						}
					})
				}
				this.closeDrawer();
			},
			loginout(){
				// localStorage.clear();
				// setTimeout(()=>{
				// 	location.reload();
				// },100)
				// window.close();
				// let routeUrl = this.$router.resolve({
				// 	path: '/login'
				// });
				// window.open(routeUrl.href, '_blank');
				
				// this.$router.replace({
				// 	path: '/login'
				// })
				this.$confirm('正在退出登录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let res = await this.$http.get(this.$api.userManage.loginout);
					if(res.code==1){
						sessionStorage.clear();
						setTimeout(()=>{
							this.$router.replace('/login')
							// location.reload();
						},100)
					}
				}).catch(() => {
				});
			},
			personalCenter(){
				this.$router.push({ path: '/personal' })
			},
			// socket初始化
			socketInit() {
				// 开发地址
				// let url = 'ws://192.168.1.17:30010/sylas/notice/' + this.userInfo.id
				// 测试地址
				// let url = 'ws://sdktest.richmob.cn/sylas//notice/' + this.userInfo.id
				// 生产地址
				let url = 'wss://sdk.richmob.cn/sylas/notice/' + this.userInfo.id
				this.websock = new WebSocket(url); // 创建websocket连接
				this.websock.onopen = this.websockOpen; // 监听打开事件注册
				this.websock.onclose = this.websockClose; // 监听关闭事件注册
				this.websock.onerror = this.websockError; //监听异常事件注册
				this.websock.onmessage = this.websockMessage; //监听服务器发送的消息
			},
			websockOpen() {
				console.log('连接成功');
				this.start();
			},
			websockClose() {
				console.log('通道关闭')
				// clearInterval(this.timeoutObj)
				// this.timeoutObj = null
				// this.socketInit();
				clearInterval(this.timeoutObj)
				this.timeoutObj = null
				clearTimeout();
				setTimeout(()=>{
					this.socketInit();
				},10000)
			},
			websockError() {
				// this.socketInit();
				// clearInterval(this.timeoutObj)
				// this.timeoutObj = null
				// this.socketInit();
				console.log('监听异常')
			},
			websockMessage(e) {
				// console.log('监听服务器发送的消息',e.data)
				let data = JSON.parse(e.data)
				if (data.type == 2) {
					console.log('监听服务器发送的消息',data)
					// this.speak("您有一条新审核消息,请及时查看");
					this.$store.commit('changeReadStatus', 1);
				}
			},
			// 使用浏览器自带的音频播报
			speak(txt) {
				if ("speechSynthesis" in window) {
					// 停止当前正在播放的语音
					window.speechSynthesis.cancel();
					const utterance = new SpeechSynthesisUtterance(txt);
					utterance.lang = "zh-CN"; // 设置语言为中文
					// 确保语音引擎已加载
					if (window.speechSynthesis.getVoices().length === 0) {
						window.speechSynthesis.onvoiceschanged = () => {
							window.speechSynthesis.speak(utterance);
						};
					} else {
						window.speechSynthesis.speak(utterance);
					}
				} else {
					alert("您的浏览器不支持语音播报功能");
				}
			},
			start() {
				// 发送心跳
				clearInterval(this.timeoutObj)
				this.timeoutObj = setInterval(() => {
					let data = {
						type: 1,
						content: '心跳检测'
					}
					this.websock.send(JSON.stringify(data))
				}, 1 * 30 * 1000)
			},
		},
		created() {
			this.initMenuCollapseStatus();
			this.token = sessionStorage.getItem("token-sdk-system");
			if(!this.token){
				this.$router.replace({
					path: '/login'
				})
				return
			}
			let navList = localStorage.getItem('sdk-navList')
			if(navList){
				navList = JSON.parse(navList)
				// console.log(navList)
				this.$store.commit('changeNavList', JSON.parse(JSON.stringify(navList)));
			}
			if(sessionStorage.getItem('sdk-userinfo')){
				this.userInfo = JSON.parse(sessionStorage.getItem('sdk-userinfo'))
			}
			if(sessionStorage.getItem('sdk-permissions')){
				this.$store.commit('changePermissions', JSON.parse(sessionStorage.getItem('sdk-permissions')));
			}
			if(localStorage.getItem('sdk-visitedViews')){
				this.$store.commit('changeVisitedViews', JSON.parse(localStorage.getItem('sdk-visitedViews')));
			}
			// console.log(this.$route.path)
			// this.getRouters();
			this.socketInit();
			this.getFirstUnRead();
		},		mounted() {					},	}</script><style scoped>
	.main{
		width: 100%;
		box-sizing: border-box;
	}
	.sideNav{
		/* width: 200px; */
		flex-shrink: 0;
		box-shadow: 4px 0px 6px 0px rgba(170,170,170,0.1);
	}
	.mainPage{
		flex: 1;
		/* width: calc(100vw - 200px); */
		box-sizing: border-box;
		position: relative;
		/* background-color: #eff2fa; */
		background: #EFF3F5;
		overflow: hidden;
	}	.navTop{
		height: 64px;
		/* background: linear-gradient(to right, #4568dc, #b06ab3); */
		background: #FFFFFF;
		/* box-shadow: 0 5px 5px -3px rgb(0 0 0 / 15%); */
		padding: 0 24px;
		box-sizing: border-box;
		border-bottom: 1px solid #EFEFEF;
		align-items: center;
		position: fixed;
		left: 200px;
		top: 0;
		right: 0;
		z-index: 10;
	}
	.navImg{
		width: 35px;
		height: 35px;
		border-radius: 50%;
		overflow: hidden;
	}
	.navTitle{
		color: rgba(255, 255, 255, 0.8);
		font-size: 20px;
		font-weight: 800;
		text-transform: uppercase;
		letter-spacing: 1px;
		line-height: 70px;
		margin-left: 15px;
		white-space:nowrap;
		width: 165px;
	}
	.searchInput{
		padding: 0 10px;
		width: 79%;
		height: 36px;
		line-height: 36px;
		background-color: rgba(255, 255, 255, 0.2);
		border-radius: 4px 0 0 4px;
		margin-left: 20px;
	}
	.searchInput input{
		border: none;
		color: #fff;
		font-size: 14px;
		background: none;
		width: 100%;
	}
	.searchBtn{
		background-color: rgba(255, 255, 255, 0.3);
		width: 45px;
		height: 36px;
		border-color: transparent;
		border-radius: 0 4px 4px 0;
		align-items: center;
		overflow: hidden;
		cursor: pointer;
	}
	.searchBtn img{
		width: 24px;
		height: 24px;
	}
	.userHead{
		align-items: center;
		cursor: pointer;
	}
	.isCollapseMenu{
		width: 40px;
		height: 40px;
		font-size: 24px;
		cursor: pointer;
		line-height: 40px;
		color: #666666;
	}
	.msgImg{
		width: 24px;
		height: 24px;
		cursor: pointer;
		position: relative;
		margin-left: auto;
	}
	.msgImg img{
		width: 100%;
		height: 100%;
	}
	.newMsgLabel{
		position: absolute;
		right: 4px;
		top: 4px;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #FC474C;
	}
	.splitLine{
		width: 1px;
		height: 24px;
		background: #F0F0F0;
		margin: 0 20px;
	}
	.headImg{
		width: 32px;
		height: 32px;
		/* margin-left: 30px; */
		border-radius: 50%;
		overflow: hidden;
		cursor: pointer;
	}
	.userName{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 8px;
		margin-right: 4px;
	}
	.searchInput input::-webkit-input-placeholder { /* WebKit, Blink, Edge */    color:    #fff; }
	
	img{
		width: 100%;
		height: 100%;
	}
	
	
	.drawHead{
		height: 48px;
		align-items: center;
		padding: 0 12px;
		box-sizing: border-box;
	}
	.drawHead i{
		cursor: pointer;
		font-size: 24px;
	}
	.drawTitles{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		height: 48px;
		align-items: center;
	}
	.drawTitles img{
		width: 24px;
		height: 24px;
		margin-left: 2px;
		cursor: pointer;
	}
	.msgBox{
		background: #F2F3F6;
		height: calc(100vh - 48px);
	}
	.msgLeft{
		width: 160px;
		height: 100%;
		background: #FFFFFF;
		flex-shrink: 0;
	}
	.leftMsgRow{
		width: 100%;
		height: 44px;
		font-size: 14px;
		color: #333333;
		line-height: 44px;
		align-items: center;
		padding: 0 16px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.leftMsgRow img{
		width: 20px;
		height: 20px;
		margin-right: 12px;
	}
	.leftTabActive{
		background: #F2F3F6;
	}
	.msgRight{
		position: relative;
		height: calc(100vh - 48px);
		/* flex: 1; */
		width: 100%;
		box-sizing: border-box;
	}
	.msgRightBox{
		height: calc(100vh - 48px);
		overflow-y: scroll !important;
		padding: 10px;
		padding-bottom: 50px;
		box-sizing: border-box;
	}
	.msgRightList{
		width: 100%;
	}
	.paging{
		background: #F2F3F6;
		width: 100%;
		position: absolute;
		left: 0;
		bottom: 0;
		padding: 10px;
		box-sizing: border-box;
	}
	.msgRightRow{
		background: #FFFFFF;
		border-radius: 4px;
		padding-bottom: 12px;
		margin-bottom: 10px;
	}
	.msgRightTitRow{
		padding: 14px;
		align-items: center;
		padding-bottom: 8px;
	}
	.redLabel{
		margin-right: 8px;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #FC474C;
	}
	.msgTitle{
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	.infoBtn{
		margin-left: auto;
		font-weight: 500;
		font-size: 14px;
		color: #007FFF;
		cursor: pointer;
	}
	.msgCont{
		font-size: 14px;
		color: #999999;
		padding: 0 14px;
	}
	.msgSplitLine{
		width: 100%;
		height: 1px;
		background: #ECEEF5;
		margin: 12px 0;
	}
	.emptyBox{
		margin-top: 100px;
	}
</style>